import React from 'react';
import './Footer.css';

const Footer = () => {
    const socialLinks = [
        { label: 'LinkedIn', href: 'https://linkedin.com/in/ashutoshshashi' },
        { label: 'X', href: 'https://twitter.com/ashutoshshashi' },
        { label: 'YouTube', href: 'https://www.youtube.com/@ashutoshshashi' },
        { label: 'Facebook', href: 'https://www.facebook.com/ashutoshshashi' },
        { label: 'Instagram', href: 'https://www.instagram.com/ashutosh_s9' }
    ];

    const professionalLinks = [
        { label: 'Google Scholar', href: 'https://scholar.google.com/citations?hl=en&user=KCXLUtIAAAAJ' },
        { label: 'Medium', href: 'https://medium.com/@ashutoshshashi' },
        { label: 'Newsletter', href: 'https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7133315405330214912' },
        { label: 'Udemy', href: 'https://www.udemy.com/user/ashutosh-shashi-4/' }
    ];

    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-brand">
                    <h2>Ashutosh Shashi</h2>
                    <p>
                        Author of 7 technology books, technology and engineering leader,
                        enterprise architect, Cloud &amp; AI advisor, mentor, educator, and speaker.
                    </p>
                </div>

                <div className="footer-nav" aria-label="Footer navigation">
                    <a href="/#introduction">Home</a>
                    <a href="/#publications">Publications</a>
                    <a href="/#knowledgeHub">Knowledge Hub</a>
                    <a href="/#resources">Resources</a>
                    <a href="/#contact">Contact</a>
                </div>

                <div className="footer-link-rows" aria-label="Profile and learning links">
                    <div className="footer-link-row" aria-label="Social and profile links">
                        {socialLinks.map((link) => (
                            <a
                                key={link.label}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={link.href}
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>

                    <div className="footer-link-row" aria-label="Professional and learning links">
                        {professionalLinks.map((link) => (
                            <a
                                key={link.label}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={link.href}
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>
                </div>

                <div className="copy-right">
                    <p>© {new Date().getFullYear()} Ashutosh Shashi. All rights reserved.</p>
                    <a href="/admin" className="footer-admin-link">Admin Access</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
